import { useState } from 'react'
import { Pagination, Autoplay, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import Banner00 from 'assets/jpg/home/banner_00.png'
import Banner01 from 'assets/jpg/home/banner_01.jpg'
import Banner02 from 'assets/jpg/home/banner_02.jpg'
import Banner03 from 'assets/jpg/home/banner_03.png'
import Banner04 from 'assets/jpg/home/banner_04.png'
import Banner05 from 'assets/jpg/home/banner_05.png'
import Banner06 from 'assets/jpg/home/banner_06.jpg'
import Banner07 from 'assets/jpg/home/banner_07.png'

import GuiaUso from 'assets/pdf/guia_de_uso_12_11.pdf'
import ModelosObrigatorios from 'assets/xlsx/modelos_obrigatorios.xlsx'

import * as S from './styles'

type Slide = {
  logo?: JSX.Element
  title: string
  description: string
  image: string
  cta?: string
  link?: string
}

export const Gallery = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [infoOpacity, setInfoOpacity] = useState(1)

  const handleTransparent = () => {
    if (slides.length > 1) setInfoOpacity(0)
  }

  const handleLink = (link?: string) => {
    if (link) window.open(link, '_blank')
  }

  const slides: Slide[] = [
    {
      image: Banner07,
      title: '',
      description: '',
      link: 'https://alu.sa.crossknowledge.com/sso/session/1623'
    },
    {
      image: Banner00,
      title: 'Planilha de Cadastro da Coleção 25.26 Completa já esta disponível',
      description: '',
      link: 'https://alpargatascombr.sharepoint.com/:f:/r/sites/LojaPerfeitaBrasil/Documentos/Sortimento%20Brasil/09.%20Cole%C3%A7%C3%B5es/Cole%C3%A7%C3%A3o%2025.26/Map%C3%A3o/fotos%20-%20modelos%20basicos%2025.26?csf=1&web=1&e=pHl5Pr&xsdata=MDV8MDJ8fDI3ZDA2YjZkMDBlMjQ2N2VmZGM3MDhkZDNmOTRkY2ZjfGZjMGJjYTJjNTE2MzRkNTI5ZGIwZDYxNDEwNjFlNzY1fDB8MHw2Mzg3MzY2MzA3NTE3NTU3MTl8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxMMk5vWVhSekx6RTVPakV4TVRJMFlUQmlMV00wWVdNdE5EWTFOeTFoT1dRMExUQTNOMlZpWWpJM01qSm1ObDltT1dNeU9HWTRaaTA1WVdNMExUUmtZVEF0WVdOa09DMWlOak16TkRNNU5XWTVNek5BZFc1eExtZGliQzV6Y0dGalpYTXZiV1Z6YzJGblpYTXZNVGN6T0RBMk5qSTNORGMwT0E9PXxhNTM1OTJjNjMyNGU0ZmY0ZmRjNzA4ZGQzZjk0ZGNmY3w0ZjExM2EzYTEyZTY0ZWY1YTRlNzI1YTk2NmNkMjRmNQ%3D%3D&sdata=T1ZFbDJSdFVzbk5xZXNGOGlyK1VZTU5mOWRObzhNb2JFRXVOSi8wN0h4dz0%3D&ovuser=fc0bca2c-5163-4d52-9db0-d6141061e765%2cltiba.ext%40alpargatas.com'
    },
    {
      image: Banner01,
      title: 'Coleção 25.26 no ar!',
      description: 'Bora vender muito a coleção mais linda dos últimos anos!'
    },
    {
      image: Banner02,
      title: 'O Q3 já começou!',
      description: 'Bora garantir o 21/24 meses de meta entregue!'
    },
    {
      image: Banner03,
      title: 'Não esquecer dos modelos obrigatórios!',
      description:
        'Garanta que seus clientes estejam abastecidos dos modelos obrigatórios de cada canal',
      link: ModelosObrigatorios
    },
    {
      image: Banner06,
      title: 'Kids & Baby: A categoria precisa ser nossa!',
      description: 'Precisamos distribuir  e ganhar no PDV!'
    },
    {
      image: Banner04,
      title: 'As pílulas sobre o Portal já estão disponíveis no Sales Academy!',
      description: 'Clique aqui e acesse agora mesmo.',
      link: 'https://alu.sa.crossknowledge.com/site/path/1550'
    },
    {
      image: Banner05,
      title: 'Nova ferramenta de metas!',
      description:
        'Clique aqui e descubra como a nova ferramenta de metas irá funcionar.',
      link: GuiaUso
    }
  ]

  return (
    <S.Wrapper>
      <S.SwiperPanel hasLink={!!slides[currentSlide].link}>
        <S.InfoContainer opacity={infoOpacity}>
          {slides[currentSlide].logo && <>{slides[currentSlide].logo}</>}
          <S.InfoTitle>{slides[currentSlide].title}</S.InfoTitle>
          {slides[currentSlide].description && (
            <S.InfoDescription>{slides[currentSlide].description}</S.InfoDescription>
          )}
          {slides[currentSlide].cta && (
            <S.InfoBullet>{slides[currentSlide].cta}</S.InfoBullet>
          )}
        </S.InfoContainer>
        <Swiper
          loop={slides.length > 1}
          height={256}
          slidesPerView={1}
          navigation
          modules={[Pagination, Autoplay, Navigation]}
          pagination={{ type: 'bullets', clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
          onTouchMove={handleTransparent}
          onTouchEnd={() => setInfoOpacity(1)}
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
        >
          {slides.map((slide, index) => {
            return (
              <SwiperSlide key={`slide-${index}`} onClick={() => handleLink(slide.link)}>
                <S.SwiperImage src={slide.image} />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </S.SwiperPanel>
    </S.Wrapper>
  )
}
